import React from "react";
import { useNavigate } from "react-router-dom";
import Button from "../componentLibrary/Button";

const TEAM_PHOTOS_GROUP_1 = [
  {
    src: "https://d2c85asnp7to29.cloudfront.net/1757357970743-thumbnail_Photo%20head%20shot%20Steven_Neuberg_021%20%28Jan%202024%29.jpg",
    alt: "Steven Neuberg, Ph.D.",
  },
  {
    src: "https://d2c85asnp7to29.cloudfront.net/1757901637810-mcdavis.png",
    alt: "Mary Davis, Ph.D.",
  },
  {
    src: "https://d2c85asnp7to29.cloudfront.net/1757901445985-DaveSmaller.jpg",
    alt: "David Lundberg-Kenrick",
  },
];

const TEAM_PHOTOS_GROUP_2 = [
  {
    src: "https://d2c85asnp7to29.cloudfront.net/1757358217170-Lex.jpg",
    alt: "Lexandra Saguid",
  },
  {
    src: "https://d2c85asnp7to29.cloudfront.net/1757358148163-Erin.jpg",
    alt: "Erin Rosenthal, M.S.",
  },
  {
    src: "https://d2c85asnp7to29.cloudfront.net/1757901801763-bobandbobette.jpg",
    alt: "Robert Cialdini and Bobette Gorden",
  },
];

const TeamPhotoRow = ({
  photos,
}: {
  photos: { src: string; alt: string }[];
}) => (
  <div className="flex justify-center">
    <div className="flex w-full max-w-2xl justify-center space-x-2 sm:space-x-4 md:space-x-8">
      {photos.map((photo) => (
        <div
          key={photo.alt}
          className="flex-1 aspect-square rounded-full overflow-hidden border-2 sm:border-4 border-electrum"
        >
          <img
            src={photo.src}
            alt={photo.alt}
            className="w-full h-full object-cover"
          />
        </div>
      ))}
    </div>
  </div>
);

const PflStorySection = () => {
  const navigate = useNavigate();

  return (
    <div id="story" className="py-20 bg-electrum-50">
      <div className="max-w-4xl mx-auto px-4">
        <h2 className="text-5xl font-bold text-electrum text-center mb-12">
          The Psych for Life<sup>®</sup> Story
        </h2>

        <TeamPhotoRow photos={TEAM_PHOTOS_GROUP_1} />

        <div className="space-y-8 text-lg text-gray-800 mt-8">
          <p>
            What happens when two professors, a filmmaker, and a
            scholar-philanthropist commit to making psychological science more
            useful in everyday life?
          </p>

          <p className="text-center text-xl font-semibold">
            You get Psych for Life<sup>®</sup>.
          </p>

          <p>
            Within a highly respected department within a highly innovative
            university, two psychology professors saw a problem: So many
            powerful insights were buried in jargon-filled journals or available
            only through professional channels. Helpful, sure, but not
            effectively reaching the people who could use them most to improve
            their everyday lives.
          </p>

          <p>
            They decided to change that. The research psychologists recruited
            the filmmaker, partnered with visionary philanthropists, and pulled
            together a creative team of students and professionals. After some
            trial and error, a lot of coffee, and the wisdom and support of an
            external advisory board of professionals across the fields of
            behavioral health, technology, and business, a web app was born to
            bring the best psychological tools to your daily life.
          </p>

          <div className="my-8">
            <TeamPhotoRow photos={TEAM_PHOTOS_GROUP_2} />
          </div>

          <p className="text-center text-xl font-semibold">
            Welcome to Psych for Life<sup>®</sup>, beta version!
          </p>

          <div className="text-center">
            <p className="mb-8">
              Click the link to learn more about our team, our mission, and our
              values.
            </p>
            <div className="flex justify-center">
              <Button
                variant="primary"
                className="px-8 py-3 rounded-lg"
                onClick={() => navigate("/about-us")}
              >
                Learn More About Us
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PflStorySection;
